<div class="tw-flex tw-flex-col tw-font-inter  tw-py-6 tw-pb-10 lg:tw-pb-6 tw-gap-4 tw-px-4 lg:tw-px-0 tw-w-full lg:tw-max-w-[850px] xl:tw-max-w-[1200px] tw-mx-auto">
  @if (isLoading() && zones().length === 0) {
    <div class="tw-flex tw-flex-col tw-gap-3 tw-w-full tw-mx-auto">
      @for (_skeleton of [1, 2, 3]; track $index) {
        <div class="tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white tw-px-5 tw-py-4 tw-flex tw-flex-col tw-gap-3">
          <div class="tw-h-4 tw-w-28 tw-rounded tw-bg-gray-200 tw-animate-pulse"></div>
          <div class="tw-h-10 tw-w-full tw-rounded-lg tw-bg-gray-200 tw-animate-pulse"></div>
          <div class="tw-h-4 tw-w-32 tw-rounded tw-bg-gray-200 tw-animate-pulse"></div>
          <div class="tw-h-10 tw-w-full tw-rounded-lg tw-bg-gray-200 tw-animate-pulse"></div>
        </div>
      }
    </div>
  } @else {
    @if (zones().length > 0) {
      <div class="tw-pb-2 lg:tw-pb-6">
        <div class="tw-flex tw-flex-col tw-justify-between tw-gap-0 lg:tw-gap-1">
          <h1 class="tw-text-gray-700 tw-text-lg lg:tw-text-2xl tw-font-bold tw-font-inter tw-leading-7 lg:tw-leading-[125%]">Zone Management</h1>
          <p class="tw-tracking-[5%] tw-text-gray-500 tw-text-sm lg:tw-text-base tw-font-normal tw-font-inter tw-leading-7">
            Manage event zones, approvals, and compliance with authorities.
          </p>
        </div>
      </div>
    }

    @if (zones().length === 0) {
      <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-gap-4">
        <img src="assets/images/v2/Location search-bro.svg" alt="No zones" class="tw-w-full md:tw-w-[400px]" />
        <div>
          <h1 class="tw-text-lg lg:tw-text-xl tw-text-gray-900 tw-font-bold tw-text-center tw-mb-2 tw-font-inter">No zones yet!</h1>
          <p class="tw-text-center tw-text-gray-500 tw-font-medium tw-text-sm lg:tw-text-base">Create zones to manage capacity, approvals, and access for this event.</p>
        </div>

        <button
          type="button"
          class="tw-font-inter tw-bg-blue-600 tw-text-white tw-text-sm lg:tw-text-base tw-font-medium tw-rounded-lg tw-px-5 tw-py-2.5 lg:tw-py-[14px] tw-flex tw-items-center tw-justify-center tw-gap-2 tw-h-10 lg:tw-h-[52px] lg:tw-w-[420px]"
          (click)="createZone()"
        >
          <i class="fas fa-plus tw-text-white tw-text-base"></i>
          Create zone
        </button>
      </div>
    } @else {
      <div class="tw-flex tw-flex-col tw-gap-3 tw-w-full tw-mx-auto">
        <div
          cdkDropList
          [cdkDropListAutoScrollDisabled]="isTouchDevice"
          [cdkDropListAutoScrollStep]="18"
          (cdkDropListDropped)="onDrop($event)"
          [cdkDropListData]="zones()"
          [cdkDropListDisabled]="isLoading() || activeDraftZoneId() != null"
          class="zone-drag-list tw-flex tw-flex-col tw-gap-3"
        >
          @for (zone of zones(); track zone.id) {
            <div
              cdkDrag
              [cdkDragDisabled]="!canDragZone(zone.id)"
              cdkDragLockAxis="y"
              class="zone-drag-item tw-group tw-relative tw-transition-transform tw-duration-150"
              [ngClass]="{ 'is-dragging': draggingZoneId() === zone.id, 'is-draft': activeDraftZoneId() === zone.id }"
              (mousedown)="onCardMouseDown(zone.id)"
              (mouseup)="onCardMouseUp(zone.id)"
              (mouseleave)="onCardMouseUp(zone.id)"
              (cdkDragStarted)="toggleDragging(zone.id, true); onDragStarted($event.source)"
              (cdkDragEnded)="toggleDragging(zone.id, false); onDragEnded()"
            >
              @if (activeDraftZoneId() !== zone.id && focusedZoneId() !== zone.id) {
                <button
                  type="button"
                  cdkDragHandle
                  class="zone-drag-handle tw-absolute tw-left-0 tw-top-0 tw-z-10 tw-h-full tw-w-4 tw-rounded-l-lg tw-flex tw-items-center tw-justify-center tw-opacity-0 group-hover:tw-opacity-100 tw-transition-all tw-duration-200"
                  [ngClass]="draggingZoneId() === zone.id ? 'tw-bg-blue-600 tw-opacity-100' : 'tw-bg-gray-200'"
                  aria-label="Reorder zone"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 -960 960 960"
                    fill="currentColor"
                    aria-hidden="true"
                    [ngClass]="draggingZoneId() === zone.id ? 'tw-text-white' : 'tw-text-gray-500'"
                  >
                    <path d="M360-160q-33 0-56.5-23.5T280-240q0-33 23.5-56.5T360-320q33 0 56.5 23.5T440-240q0 33-23.5 56.5T360-160Zm240 0q-33 0-56.5-23.5T520-240q0-33 23.5-56.5T600-320q33 0 56.5 23.5T680-240q0 33-23.5 56.5T600-160ZM360-400q-33 0-56.5-23.5T280-480q0-33 23.5-56.5T360-560q33 0 56.5 23.5T440-480q0 33-23.5 56.5T360-400Zm240 0q-33 0-56.5-23.5T520-480q0-33 23.5-56.5T600-560q33 0 56.5 23.5T680-480q0 33-23.5 56.5T600-400ZM360-640q-33 0-56.5-23.5T280-720q0-33 23.5-56.5T360-800q33 0 56.5 23.5T440-720q0 33-23.5 56.5T360-640Zm240 0q-33 0-56.5-23.5T520-720q0-33 23.5-56.5T600-800q33 0 56.5 23.5T680-720q0 33-23.5 56.5T600-640Z" />
                  </svg>
                </button>
              }
              <app-zone-card
                class="tw-w-full"
                [zone]="zone"
                [isDragging]="draggingZoneId() === zone.id"
                [isHighlighted]="activeDraftZoneId() === zone.id"
                [isFocused]="focusedZoneId() === zone.id"
                [errors]="zoneErrors().get(zone.id)"
                (nameChanged)="onZoneNameChanged($event)"
                (nameBlurred)="onDraftNameBlur($event)"
                (focusChanged)="onZoneFocusChanged($event)"
                (capacityChanged)="onZoneCapacityChanged($event)"
                (deleteClicked)="onZoneDeleted($event)"
              ></app-zone-card>
            </div>
          }
        </div>

        <div class="tw-flex tw-items-center tw-justify-between tw-w-full tw-h-10">
          <button
            type="button"
            class="tw-inline-flex tw-items-center tw-gap-2 tw-self-start tw-px-3 tw-py-2 tw-rounded-lg tw-text-blue-600 tw-text-sm tw-font-medium tw-transition-colors"
            (click)="createZone()"
          >
            <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.1111 7.11111H8.88889V0.888889C8.88889 0.653141 8.79524 0.427048 8.62854 0.260349C8.46184 0.0936505 8.23575 0 8 0C7.76425 0 7.53816 0.0936505 7.37146 0.260349C7.20476 0.427048 7.11111 0.653141 7.11111 0.888889V7.11111H0.888889C0.653141 7.11111 0.427048 7.20476 0.260349 7.37146C0.0936505 7.53816 0 7.76425 0 8C0 8.23575 0.0936505 8.46184 0.260349 8.62854C0.427048 8.79524 0.653141 8.88889 0.888889 8.88889H7.11111V15.1111C7.11111 15.3469 7.20476 15.573 7.37146 15.7397C7.53816 15.9064 7.76425 16 8 16C8.23575 16 8.46184 15.9064 8.62854 15.7397C8.79524 15.573 8.88889 15.3469 8.88889 15.1111V8.88889H15.1111C15.3469 8.88889 15.573 8.79524 15.7397 8.62854C15.9064 8.46184 16 8.23575 16 8C16 7.76425 15.9064 7.53816 15.7397 7.37146C15.573 7.20476 15.3469 7.11111 15.1111 7.11111Z" fill="currentColor"/>
            </svg>
            Add zone
          </button>

          @if (hasPendingChanges()) {
            <button
              type="button"
              class="tw-inline-flex tw-items-center tw-gap-2 tw-px-5 tw-py-2.5 tw-rounded-lg tw-bg-blue-600 tw-text-white tw-text-sm tw-font-medium hover:tw-bg-blue-700 tw-transition-colors"
              (click)="saveZones()"
            >
              Save
            </button>
          }
        </div>
        @if (isLoading() && zones().length > 0) {
          <div class="tw-flex tw-items-center tw-justify-center tw-py-3">
            <progress-circle [isInfinite]="true" colorClasses="tw-border-blue-600 tw-border-t-transparent"></progress-circle>
          </div>
        }
        <div #loadMoreTrigger class="tw-h-2 tw-w-full" aria-hidden="true"></div>
      </div>
    }

  }
</div>

@if (isModalOpened(deleteModalId)) {
  <delete-modal
    [id]="deleteModalId"
    [message]="deleteZoneConfirmMessage()"
    (onDelete)="confirmZoneDeletion()"
    (onCancel)="cancelZoneDeletion()"
  ></delete-modal>
}
